import firebase from 'firebase';


var config = {
    apiKey: "AIzaSyA1R105aNYPNhYBOKHtXoCn0Yff6d_oMG4",
    authDomain: "builditornot.firebaseapp.com",
    databaseURL: "https://builditornot.firebaseio.com",
    projectId: "builditornot",
    storageBucket: "",
    messagingSenderId: "1050066205773"
  };
  var app = firebase.initializeApp(config);

  export default app;


// WEBPACK FOOTER //
// ./src/fire.js